(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-family-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    document.querySelectorAll('[data-family-nav]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const choices = [...nav.querySelectorAll('[data-family-choice]')];
      const panels = [...nav.querySelectorAll('[data-family-panel]')];
      let timer;
      const choose = button => {
        clearTimeout(timer);
        choices.forEach(choice => choice.setAttribute('aria-expanded', String(choice === button)));
        panels.forEach(panel => panel.hidden = panel.dataset.familyPanel !== button.dataset.familyChoice);
      };
      choices.forEach(button => {
        button.addEventListener('click', () => choose(button));
        button.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(timer);
          timer = setTimeout(() => choose(button), 180);
        });
        button.addEventListener('pointerleave', () => clearTimeout(timer));
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') {
            event.preventDefault(); choose(button);
            nav.querySelector('[data-family-panel]:not([hidden]) a')?.focus();
          }
        });
      });
    });
    document.querySelectorAll('.ts-nav-disclosure').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const item = button.closest('.list-menu-item');
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      const sync = () => {
        const open = item.classList.contains('list-menu--megamenu-visible');
        button.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
      };
      const open = value => {
        if(value) item.parentElement.querySelectorAll(':scope>.list-menu--megamenu-visible').forEach(other => {
          if (other !== item) other.classList.remove('list-menu--megamenu-visible');
        });
        item.classList.toggle('list-menu--megamenu-visible', value); sync();
      };
      new MutationObserver(sync).observe(item, {attributes:true,attributeFilter:['class']});
      sync();
      button.addEventListener('click', () => open(button.getAttribute('aria-expanded') !== 'true'));
      const label = item.querySelector(':scope > a');
      if (label && label.getAttribute('href') === '#') label.addEventListener('click', event => {event.preventDefault();open(button.getAttribute('aria-expanded') !== 'true');});
      item.addEventListener('keydown', event => {
        if(event.key === 'Escape') {event.preventDefault();event.stopPropagation();open(false);button.focus();}
        if(event.key === 'ArrowDown' && event.target === button) {event.preventDefault();open(true);panel.querySelector('a,button')?.focus();}
      });
      item.addEventListener('focusout', event => {if(!item.contains(event.relatedTarget))open(false);});
      document.addEventListener('pointerdown', event => {if(!item.contains(event.target))open(false);});
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
